<template>
  <b-card>
    <b-row>
      <!-- <label>Exportera till Excel:</label> -->
      <b-form-group>
        <b-form-radio v-model="whatToExport" name="some-radios" value="ALL"
          >Allt</b-form-radio
        >
        <b-form-radio v-model="whatToExport" name="some-radios" value="PAGE"
          >Endast denna sida</b-form-radio
        >
        <b-form-radio
          v-if="keys && keys.length > 0"
          v-model="whatToExport"
          name="some-radios"
          value="SELECTION"
          >Markerade ({{ keys.length }})</b-form-radio
        >
      </b-form-group>
    </b-row>
    <b-row>
      <label>Begränsning:</label>
    </b-row>
    <b-row>
      <p>Max antal poster:</p>
      <br />
      <b-form-input v-model="maxRows"></b-form-input>
    </b-row>
    <b-row>
      <b-button variant="primary" @click="Export()">Exportera</b-button>
      <!-- <b-button variant="primary" @click="ExportJs()">Exportera JS</b-button> -->
      <div class="input-groun-append" v-if="isBusy">
        <b-icon icon="arrow-clockwise" animation="spin" font-scale="2"></b-icon>
      </div>
    </b-row>
    <b-row v-if="url">
      <b-card>
        <label>Ladda ned dokument:</label><br />
        <a v-bind:href="url">{{ filename }}</a>
      </b-card>
    </b-row>
  </b-card>
</template>
<script>
import XLSX from 'xlsx'; 
import { Api } from "../../lib/api";
const api = new Api();

export default {
  name: "queryviewexport",
  props: { keys: Array, id: Number, startRow: Number, endRow: Number },
  data() {
    return {
      whatToExport: "ALL",
      maxRows: 10000,
      url: null,
      filename: null,
      isBusy: false,
    };
  },
  methods: {
    Export() {
      var b = { id: this.id, maxRecords: this.maxRows };
      switch (this.whatToExport) {
        case "PAGE":
          b.startRow = this.startRow;
          b.endRow = this.endRow;
          break;

        case "SELECTION":
          b.keys = this.keys;
          break;
      }
      this.isBusy = true;
      api.download("/api/apiqueryview/exportxlsx?reqjson="+JSON.stringify(b)).then((res)=> {
        this.isBusy = false;
      });
      // api.post("/api/apiqueryview/PerformExport", b).then((res) => {
      //   //window.open(res.data.link);
      //   this.isBusy = false;
      //   var lnk = res.data.link;
      //   if (lnk.substr(0, 4) != "http") {
      //     lnk = api.baseUrl + lnk;
      //   }
      //   this.url = lnk;
      //   this.filename = "Excel-fil";
      // });
      console.log("Exportera!");
    },
    // ExportJs() {
    //   alert('ExportJs');
    //   var x = {
    //     cols: [
    //       { name: "A", key: 0 },
    //       { name: "B", key: 1 },
    //       { name: "C", key: 2 },
    //     ],
    //     data: [
    //       ["id", "name", "value"],
    //       [1, "sheetjs", 7262],
    //       [2, "js-xlsx", 6969],
    //     ],        
    //   };
    //   const ws = XLSX.utils.aoa_to_sheet(x);
		// 	const wb = XLSX.utils.book_new();
		// 	XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		// 	/* generate file and send to client */
		// 	XLSX.writeFile(wb, "sheetjs.xlsx");
    // },
  },
};
</script>
